import React from 'react';
import { Typography, useMediaQuery } from 'fronton-react';
import { LayingTypeLabel } from 'pages/common/components/LayingTypeField/const';

const DATA_TEST_ID = 'configuration-additional-info';

const Info = ({ title }: { title: string }) => {
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  if (isMobile) {
    return (
      <Typography size="caption" variant="minor" color="text-primary" data-testid={DATA_TEST_ID}>
        {title}
      </Typography>
    );
  }

  return (
    <Typography size="body_long" variant="s" color="text-primary" data-testid={DATA_TEST_ID}>
      {title}
    </Typography>
  );
};

export const AdditionalInfo = ({ typeInstallation }: { typeInstallation?: string }) => {
  if (typeInstallation) {
    return (
      <Info
        title={`Направление укладки: ${LayingTypeLabel[typeInstallation as 'horizontal' | 'diagonal']}`}
      />
    );
  }

  return null;
};
